module.exports = __webpack_public_path__ + "img/emiarch-3-sel.8e9ec4b3.svg";